(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
  function getBar() {
    var bars = document.querySelectorAll('[data-chawu-sticky-atc]');
    if (bars.length > 1) {
      for (var i = 1; i < bars.length; i += 1) {
        if (bars[i].parentNode) bars[i].parentNode.removeChild(bars[i]);
      }
    }
    return bars[0] || null;
  }
  var bar = getBar();
  if (!bar) return;
  function sync() {
    bar = getBar();
    if (!bar) { clearInterval(timer); return; }
    /* Move the fixed bar to <body> so no transformed ancestor (Dawn
       scroll-trigger/animate--slide-in) can hijack its containing block. */
    if (bar.parentNode && bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }
    var barPrice = bar.querySelector('.price');
    var barAdd = bar.querySelector('button[name="add"]');
    var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    var mainAdd = mainForm ? mainForm.querySelector('button[name="add"]') : null;
    var mainPrice = document.querySelector('.product__info-container [role="status"] .price');
    if (barPrice && mainPrice && barPrice.innerHTML !== mainPrice.innerHTML) {
      barPrice.innerHTML = mainPrice.innerHTML;
    }
    if (barAdd && mainAdd) {
      if (barAdd.disabled !== mainAdd.disabled) barAdd.disabled = mainAdd.disabled;
      bar.style.display = mainAdd.disabled ? 'none' : '';
    }
  }
  sync();
  var timer = setInterval(sync, 400);
})();
  } catch(e) { console.error(e); }
})();

})();
